import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { OciService } from './oci.service';

@Injectable({ providedIn: 'root' })
export class MediaFallbackService {
  private readonly objectUrls = new Set<string>();
  private readonly blobCache = new Map<string, Promise<Blob>>();

  constructor(private ociService: OciService) {}

  buildCdnUrl(filePath: string | null | undefined): string {
    if (!filePath) {
      return '';
    }

    return `${environment.cdnBaseUrl}?key=${encodeURIComponent(filePath)}`;
  }

  async getFallbackObjectUrl(filePath: string | null | undefined): Promise<string | null> {
    if (!filePath) {
      return null;
    }

    let blobRequest = this.blobCache.get(filePath);
    if (!blobRequest) {
      blobRequest = firstValueFrom(this.ociService.getOciResourceEnhancedWithoutSpinner(filePath))
        .catch((error) => {
          this.blobCache.delete(filePath);
          throw error;
        });
      this.blobCache.set(filePath, blobRequest);
    }

    const blob = await blobRequest;
    const objectUrl = URL.createObjectURL(blob);
    this.objectUrls.add(objectUrl);
    return objectUrl;
  }

  releaseObjectUrl(objectUrl: string | null | undefined): void {
    if (!objectUrl || !this.objectUrls.has(objectUrl)) {
      return;
    }

    URL.revokeObjectURL(objectUrl);
    this.objectUrls.delete(objectUrl);
  }
}
